import React from "react";
import SwitchOrderDetails from "../../../../featureComponent/OrderAuth/SwitchOrderDetails/SwitchOrderDetails";
import { ORDER_DETAILS as STRINGS } from "businesslogic/strings/ordersAuth";
import { formatAmountInr } from "businesslogic/utils/common/functions";
import { getOrderAuthTags } from "businesslogic/utils/ordersAuth/functions"

const SwitchFunds = ({ orders = [] }) => {
  return (
    <div>
      {orders.map((order, index) => (
        <SwitchOrderDetails
          key={index}
          topLabel={STRINGS.switchCard.swtichFrom.text}
          bottomLabel={STRINGS.switchCard.switchTo.text}
          topTitle={order.from_name}
          bottomTitle={order.to_name}
          topIcon={order.from_amc_logo_small}
          bottomIcon={order.to_amc_logo_small}
          tags={getOrderAuthTags(order)}
          totalUnits={order.units}
          amount={formatAmountInr(order.amount)}
          noFooter
        />
      ))}
    </div>
  );
};

export default SwitchFunds;
